export default __webpack_public_path__ + "static/media/ic_module.53bef65d.svg";